import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/ico_iconSort.svg??url_encode")